var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTombstone1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10V21.25H22C22.4142 21.25 22.75 21.5858 22.75 22C22.75 22.4142 22.4142 22.75 22 22.75H2C1.58579 22.75 1.25 22.4142 1.25 22C1.25 21.5858 1.58579 21.25 2 21.25H4V10ZM12.6512 6.6279C12.5176 6.39421 12.2691 6.25 12 6.25C11.7309 6.25 11.4823 6.39421 11.3488 6.6279L10.5648 8H9C8.73265 8 8.48551 8.14232 8.35132 8.37355C8.21713 8.60479 8.21617 8.88998 8.34882 9.1221L9.13619 10.5L8.34882 11.8779C8.21617 12.11 8.21713 12.3952 8.35132 12.6264C8.48551 12.8577 8.73265 13 9 13H10.5648L11.3488 14.3721C11.4823 14.6058 11.7309 14.75 12 14.75C12.2691 14.75 12.5176 14.6058 12.6512 14.3721L13.4352 13H15C15.2674 13 15.5145 12.8577 15.6487 12.6264C15.7829 12.3952 15.7838 12.11 15.6512 11.8779L14.8638 10.5L15.6512 9.1221C15.7838 8.88998 15.7829 8.60479 15.6487 8.37356C15.5145 8.14232 15.2674 8 15 8H13.4352L12.6512 6.6279Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTombstone1);
export default __webpack_public_path__ + "static/media/tombstone-1.0a7508e4e915d78b22fae9ea0257f606.svg";
export { ForwardRef as ReactComponent };